var path = '/client/common/modules/accordion-box/views/accordion-box-content.html';
var html = "<div class=\"accordion-box-content\" ng-transclude></div>";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;